import React, { useState } from 'react';
import './data-table.css';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper, 
  SvgIcon
} from '@mui/material';
import Modals from '../modal/modal';
import Buttons from '../button';

interface Culture {
  id: string;
  name: string;
  externalId: string;
  externalType: number;
}

interface Sector {
  id: string;
  name: string;
  nickname: string;
  externalId: string;
  externalType: number;
}

interface Farm {
  id: string;
  name: string;
  externalId: string;
  externalType: number;
}

interface Service{
  id: string;
  name: string;
  externalId: string;
  externalType: number;
}

interface Sample {
  id: string;
  externalId: string;
  culture: Culture;
  sector: Sector;
  farm: Farm;
  plot: string;
  depth: string | null;
  externalType: number;
  service: Service;
  description: string;
}

interface DataTableProps {
data: Sample[];
}

const DataTable: React.FC<DataTableProps> = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };


  return (
    <>
      <TableContainer component={Paper} sx={{minWidth:'1200px'}}>
        <Table>
          <TableHead className='import-table-head'>
            <TableRow>
              <TableCell className='import-table-columns'>AMOSTRA</TableCell>
              <TableCell className='import-table-columns'>IDENTIFICAÇÃO</TableCell>
              <TableCell className='import-table-columns'>CULTURA</TableCell>
              <TableCell className='import-table-columns'>TALHÃO</TableCell>
              <TableCell className='import-table-columns'>PROF.</TableCell>
              <TableCell className='import-table-columns'>ANÁLISE</TableCell>
              <TableCell className='import-table-columns'>FAZENDA</TableCell>
              {/*<TableCell className='import-table-columns'>AÇÃO</TableCell>*/}
            </TableRow>
          </TableHead>
          <TableBody>
          {data.map((row, index) => (
              <TableRow key={index}>
                <TableCell className='import-table-data'>{row.externalId}</TableCell>
                <TableCell className='import-table-data'>{row.description}</TableCell>
                <TableCell className='import-table-data'>{row.culture.name}</TableCell>
                <TableCell className='import-table-data'>{row.plot}</TableCell>
                <TableCell className='import-table-data'>{row.depth || 'N/A'}</TableCell>
                <TableCell className='import-table-data'>{row.service.name}</TableCell>
                <TableCell className='import-table-data'>{row.farm.name}</TableCell>
                {/*<TableCell>
                  <SvgIcon className="edit-icon" onClick={handleOpenModal} style={{ cursor: 'pointer' }}>
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 32 32"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.6906 24.25H8.5C8.30109 24.25 8.11033 24.171 7.96967 24.0304C7.82902 23.8897 7.75 23.699 7.75 23.5V19.3094C7.74966 19.212 7.76853 19.1155 7.80553 19.0254C7.84253 18.9354 7.89694 18.8534 7.96563 18.7844L19.2156 7.53441C19.2854 7.46355 19.3686 7.40728 19.4603 7.36886C19.5521 7.33045 19.6505 7.31067 19.75 7.31067C19.8495 7.31067 19.9479 7.33045 20.0397 7.36886C20.1314 7.40728 20.2146 7.46355 20.2844 7.53441L24.4656 11.7157C24.5365 11.7855 24.5928 11.8686 24.6312 11.9604C24.6696 12.0521 24.6894 12.1506 24.6894 12.25C24.6894 12.3495 24.6696 12.448 24.6312 12.5397C24.5928 12.6314 24.5365 12.7146 24.4656 12.7844L13.2156 24.0344C13.1466 24.1031 13.0647 24.1575 12.9746 24.1945C12.8845 24.2315 12.788 24.2504 12.6906 24.25V24.25Z"
                        stroke="#2D7A89"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                      <path
                        d="M16.75 10L22 15.25"
                        stroke="#2D7A89"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                </TableCell>*/}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Modals
        open={isModalOpen}
        title="Amostra editada com sucesso"
        type='edit'
        starticon={
          <svg
            width="64"
            height="64"
            viewBox="0 0 64 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_437_5154)">
              <path
                d="M22 34L28 40L42 26"
                stroke="#FF9D33"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M32 56C45.2548 56 56 45.2548 56 32C56 18.7452 45.2548 8 32 8C18.7452 8 8 18.7452 8 32C8 45.2548 18.7452 56 32 56Z"
                stroke="#FF9D33"
                stroke-width="3"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_437_5154">
                <rect width="64" height="64" fill="white" />
              </clipPath>
            </defs>
          </svg>
        }
        actions={
          <>
            {/*<Buttons
              label="Baixar Relatório"
              onClick={handleCloseModal}
              backgroundColor="var(--primary-color)"
              textColor="#fff"
              fullWidth={false}
              sx={{
                boxShadow: 'none',
                padding: '0.5rem 1rem',
                marginBottom: '0.5rem',
              }}
            />*/}
          </>
        }
        onClose={handleCloseModal}
      />
    </>   
  );
};

export default DataTable;
